<template>
  <div class="ds-control ds-form-item">
    <div
      v-if="isDesign || sPID"
      class="ds-flowprocess"
      :class="{ 'is-vertical': isVertical }"
    >
      <div v-if="!hideTitle || !hideCheckbox" class="head">
        <div v-if="!hideTitle" class="title">
          <label handler="title" class="ds-font-3">{{ title }}</label>
        </div>
        <div class="set" v-if="!hideCheckbox && !isVertical">
          <el-checkbox v-model="isHideNode" label="隐藏异常环节"></el-checkbox>
          <el-checkbox v-model="isHideYj" label="隐藏无意见环节"></el-checkbox>
        </div>
        <div class="set" v-if="!hideCheckbox && isVertical">
          <el-switch class="error" v-model="isHideNode" active-text="异常环节">
          </el-switch>
          <el-switch v-model="isHideYj" active-text="空意见环节"> </el-switch>
        </div>
      </div>
      <div class="content" handler="content">
        <div v-for="(item, index) in data" :key="index" class="item">
          <div class="fl-box">
            <span v-if="!isVertical">{{ item.reachtime }}</span>
            <span v-if="isVertical" class="node-name" :style="{textAlign: textAlign}">{{ item.nodename }}</span>
            <img
              class="tx"
              :src="
                require('_platform/assets/styles/themes/workFlow/head_logo.png')
              "
            />
            <img
              class="icon"
              :src="
                require(`_platform/assets/styles/themes/workFlow/status${getStatus(
                  item.STATUS
                )}.png`)
              "
            />
          </div>
          <div class="fr-box" :class="{ end: item.nodetype === '299' }">
            <div class="des">
              <div v-if="!isVertical">
                <span>处理环节：</span>
                <span>{{ item.nodename }}</span>
              </div>
              <div v-if="item.nodetype !== '299'">
                <span>处理人：</span>
                <span v-if="!item.signTypeValue || item.signTypeValue == '0'">{{ item.rusername }}</span>
                <DsfImage v-else :src="item.signFilePath | imgFormat" class="sign-user" :failData="' '" />
              </div>
              <div v-if="isVertical">
                <span>接收时间：</span>
                <span>{{ item.reachtime }}</span>
              </div>
              <div v-if="item.nodetype !== '299'">
                <span>签收时间：</span>
                <span>{{ item.receivetime }}</span>
              </div>
            </div>
            <div v-if="showResult && item.nodetype !== '299'" class="result">
              <div>
                <span>处理结果：</span>
                <span>{{ getResults(item) }}</span>
              </div>
            </div>
            <!-- <div v-if="item.EXSTATUS != '-8' && item.EXSTATUS != '-9' && item.nodetype !== '201' && item.nodetype !== '299'" class="yj"> -->
            <div v-if="showOpinion && showOpinion(item)" class="yj">
              <div>
                <span>处理意见：</span>
                <span>{{
                  (item.opinionatts && item.opinionatts.Content) ||
                    processingOpinion
                }}</span>
              </div>
            </div>
            <DsfFlowFileList
              v-if="showFileList(item)"
              :attachments="item.opinionatts.Attachments"
              :isVertical="isVertical"
            ></DsfFlowFileList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DsfFlowFileList =Vue.defineLazyComponent(()=>require("./flowFileList"))
export default dsf.component({
  name: "DsfFlowProcess",
  mixins: [$mixins.control],
  ctrlCaption: "办理情况",
  components: {
    DsfFlowFileList,
  },
  props: {
    caption: {
      type: String,
      default() {
        return "wfprocess";
      },
    },
    title: {
      type: String,
      default() {
        return "办理情况";
      },
    },
    hideTitle: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideCheckbox: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideNode: {
      type: Boolean,
      default() {
        return true;
      },
    },
    hideYj: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showResult: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isVertical: {
      type: Boolean,
      default() {
        return false;
      },
    },
    textAlign: {
      type: String,
      default: "right"
    },
    orderDes: {
      type: Boolean,
      default() {
        return false;
      },
    },
    processingOpinion: {
      type: String,
      default() {
        return "无数据";
      },
    },
    results: {
      type: Object,
      default() {
        return {
          "-9": "提交", // 初始化提交
          "-8": "提交", // 修改后提交
          0: "审核通过", // 环节通过
          1: "审核通过", // 流程通过
          "-1": "不通过", // 流程不通过
          "-2": "返回修改", // 环节返回修改
        };
      }
    },
    getResults: {
      type: Function,
      default(item) {
        return this.results[item.EXSTATUS];
      }
    },
    showOpinion: {
      type: Function,
      default: (item) => {
        if (item && (item.STATUS === 0 || item.STATUS === 1)) {
          return (
            item.isCurrentUser &&
            (item?.opinionatts?.Content ||
              item?.opinionatts?.Attachments?.length > 0)
          );
        }
        return (
          item &&
          (item.STATUS === 2 || item.STATUS === -4) &&
          item.nodetype !== "201" &&
          item.nodetype !== "299"
        );
      },
    },
  },
  data() {
    return {
      sPID: null,
      sCurLinkID: null,
      isHideNode: this.hideNode,
      isHideYj: this.hideYj,
    };
  },
  watch: {
    hideNode(val) {
      this.isHideNode = val;
    },
    hideYj(val) {
      this.isHideYj = val;
    },
  },
  computed: {
    data() {
      let data = [];
      if (this.isDesign || !this.sPID) {
        data = [
          {
            nodename: "开始",
            EXSTATUS: -9,
            STATUS: 0,
            linkid: "faedda583f7742948b0714f0f17d1085",
            opinionatts: JSON.stringify({
              Content: "同意",
            }),
            ruserid: "",
            pid: "af60e455757d48dd801d07b1538eb806",
            rusername: "平台管理员",
            rdeptname: "平台管理组",
            reachtime: "2020年01月06日 18:20:21",
            receivetime: "2020年01月06日 18:20:21",
          },
          {
            nodename: "审批",
            EXSTATUS: 0,
            STATUS: 1,
            linkid: "saedda583f7742948b0714f0f17d108c",
            opinionatts: JSON.stringify({
              Content: "同意",
            }),
            ruserid: "",
            pid: "sf60e455757d48dd801d07b1538eb806",
            rusername: "平台管理员",
            rdeptname: "平台管理组",
            reachtime: "2020年01月08日 18:21:25",
            receivetime: "2020年01月08日 18:22:30",
          },
          {
            nodename: "审批",
            EXSTATUS: -1,
            STATUS: -4,
            linkid: "saedda583f7742948b0714f0f17d1085",
            opinionatts: JSON.stringify({
              Content: "不同意",
            }),
            ruserid: "",
            pid: "sf60e455757d48dd801d07b1538eb806",
            rusername: "平台管理员",
            rdeptname: "平台管理组",
            reachtime: "2020年01月08日 18:21:25",
            receivetime: "2020年01月08日 18:22:30",
          },
          {
            nodename: "结束",
            nodetype: "299",
            EXSTATUS: 2,
            STATUS: 1,
            linkid: "caedda583f7742948b0714f0f17d1085",
            opinionatts: JSON.stringify({
              Content: "",
            }),
            ruserid: "",
            pid: "cf60e455757d48dd801d07b1538eb806",
            rusername: "平台管理员",
            rdeptname: "平台管理组",
            reachtime: "2020年01月09日 18:23:21",
            receivetime: "2020年01月09日 20:23:21",
          },
        ];
      }
      if (this.$vm?.flows?.flowProcess) {
        data = _.cloneDeep(this.$vm.flows.flowProcess);
      }
      return this.formatData(data);
    },
  },
  mounted() {
    const data =
      (this.$dialog &&
        this.$dialog.dialogArgs &&
        this.$dialog.dialogArgs.data &&
        this.$dialog.dialogArgs.data[0]) ||
      null;
    this.sPID = data
      ? data.sPID
      : this.queryString?.sPID || this.$route.query?.sPID || "";
    this.sCurLinkID = data
      ? data.sCurLinkID
      : this.$route.query.sCurLinkID || this.queryString.sCurLinkID;
    if (this.sPID) {
      this.init();
    }
  },
  methods: {
    init() {
      if (this.$vm?.flows?.loadFlowProcess) {
        return;
      }
      this.$vm.flows.loadFlowProcess = true;
      this.$http
        .get("wfr/getProcessInfoByPID", {
          sPID: this.sPID,
        })
        .then((res) => {
          if (res.data.success) {
            let params;
            if (this.$vm?.flows) {
              this.$set(this.$vm.flows, "flowProcess", res.data.data);
              this.$vm.flows?.flowProcess.forEach((item) => {
                if (this.sCurLinkID === item.linkid && item.nodetype != "299") {
                  this.$vm.flows.sOpinion = JSON.parse(item.opinionatts);
                }
              });
            }
            res.data.data.forEach((item) => {
              if (item.linkid === this.sCurLinkID && item.pid === this.sPID) {
                if (item.STATUS != 0 && item.STATUS != 1) {
                  params = dsf.mix({}, this.queryString, {
                    isHide: true,
                  });
                }
              }
            });
            //更新url添加id参数
            if (params) {
              if (this?.$frame?.independent) {
                this.$frame.urlChange(
                  {
                    pageName: this.$form.pageName,
                    nameSpace: this.$form.nameSpace,
                    query: params,
                  },
                  true
                );
              }
              //如果页面在dialog中不更新url中的id参数
              else if (this.$dialog) {
                this.$dialog.currentView &&
                  this.$dialog.currentView.urlChange(
                    {
                      pageName: this.$form.pageName,
                      nameSpace: this.$form.nameSpace,
                      query: params,
                    },
                    true
                  );
              } else {
                this.$router.replace({
                  path: this.$route.path,
                  query: params,
                });
              }
            }
          }
        });
    },
    getStatus(status) {
      let index;
      if (status == "-31") {
        index = "-3";
      } else if (status == "-1") {
        index = "-2";
      } else {
        index = status;
      }
      return index;
    },
    showFileList(item) {
      return this.showOpinion(item) && item.opinionatts?.Attachments?.length > 0;
    },
    formatData(list) {
      let data = [];
      list.forEach((item) => {
        item.opinionatts = JSON.parse(item.opinionatts);
        if (
          this.isHideYj &&
          !item?.opinionatts?.Content &&
          !item?.opinionatts?.Attachments
        ) {
          return;
        }
        if (this.isHideNode && item.STATUS == "-4") {
          return;
        }
        data.push(item);
      });
      if (this.orderDes) {
        return data.reverse();
      }
      return data;
    },
  },
});
</script>
